// services/bankDetailsService.js
// Direct bank-transfer details debtors pay into (stored on
// Company.emailPaymentDetails, the same details used on invoice emails).

const API_URL = process.env.REACT_APP_API_URL;
const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
});

const parse = async (res, fallback) => {
  let data = {};
  try { data = await res.json(); } catch { /* empty body */ }
  if (!res.ok || data.success === false) {
    throw new Error(data.message || fallback);
  }
  return data;
};

export const bankDetailsService = {
  async get() {
    const res = await fetch(`${API_URL}/api/company/bank-details`, { headers: authHeaders() });
    const data = await parse(res, "Couldn't load bank details.");
    return data.bankDetails || null;
  },

  async save(details) {
    const res = await fetch(`${API_URL}/api/company/bank-details`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify(details),
    });
    const data = await parse(res, "Couldn't save bank details.");
    return data.bankDetails || details;
  },
};